import './index.less';

import { Text, useColorMode, useColorStyle, Box } from '@tonic-one/react';
import { Layout } from 'antd';

export default () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  const { Footer } = Layout;
  const currentYear = new Date().getFullYear();

  return (
    <Box backgroundColor={colorStyle.background.primary}>
      <Footer className="footer">
        <Text color={colorStyle.color.secondary}>
          Copyright © {`${currentYear}`} Trend Micro Incorporated. All rights
          reserved.
        </Text>
      </Footer>
    </Box>
  );
};
